import { baseApi } from '@/services'
import { HOI, PaginatedResults } from '@/types/unlock'

export const HOIApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    listHOI: builder.query<PaginatedResults<HOI[]>, any>({
      query: (applicationUUID) => `v2/applications/${applicationUUID}/hoi/`,
      providesTags: ['HOI'],
    }),
    getHOI: builder.query<HOI, number>({
      query: (uuid) => `v2/hoi/${uuid}/`,
      providesTags: ['HOI'],
    }),
    createHOI: builder.mutation<HOI, Partial<HOI>>({
      query: (hoi) => ({
        method: 'POST',
        url: 'v2/hoi/',
        body: hoi,
      }),
      invalidatesTags: [
        'Application',
        'ApplicationOffer',
        'AutomatedApplicationExceptions',
        'HOI',
        'AtypicalityCheckCalcs',
        'ApplicationGuidelines',
        'ApplicationCalcs',
        'Alert',
        'Property',
        'PropertyV2',
      ],
    }),
    updateHOI: builder.mutation<HOI, Partial<HOI>>({
      query: (hoi) => ({
        method: 'PATCH',
        url: `v2/hoi/${hoi.uuid}/`,
        body: hoi,
      }),
      invalidatesTags: [
        'Application',
        'ApplicationOffer',
        'AutomatedApplicationExceptions',
        'HOI',
        'AtypicalityCheckCalcs',
        'ApplicationGuidelines',
        'ApplicationCalcs',
        'Alert',
        'Property',
        'PropertyV2',
      ],
    }),
    deleteHOI: builder.mutation<HOI, Partial<HOI>>({
      query: (hoi) => ({
        method: 'DELETE',
        url: `v2/hoi/${hoi.uuid}/`,
      }),
      invalidatesTags: [
        'Application',
        'ApplicationOffer',
        'AutomatedApplicationExceptions',
        'HOI',
        'AtypicalityCheckCalcs',
        'ApplicationGuidelines',
        'ApplicationCalcs',
        'Alert',
        'Property',
        'PropertyV2',
      ],
    }),
  }),
})

export const {
  useListHOIQuery,
  useGetHOIQuery,
  useCreateHOIMutation,
  useUpdateHOIMutation,
  useDeleteHOIMutation,
} = HOIApi
